{
  "Hello!": "Hello!",
  "Welcome to your learning hub.": "Welcome to your learning hub!",
  "Get started with discovering content relevant to your role, interests, and personal development by setting up an account.": "Get started and discover content relevant to you.",
  "Our Terms & Conditions": "Our Terms & Conditions",
  "Before you can start on the platform, you must agree to our Terms of Use and Privacy Notes.": "You must agree to our Terms of Use and Privacy Notice before you start.",
  "You can request a copy of your data via the Privacy Notes page at any time.": "You can request a copy of your data via the Privacy Notice page.",
  "Be aware that you are now registering to a learning platform approved but not operated by LFAB": "Be aware that you are now registering to a learning platform approved but not operated by LFAB. The platform is approved for information up to confidentiality level K2 Restricted (K2 Begränsad).",
  "Terms of Use": "Terms of Use",
  "I agree to": "I agree to <0>{{terms}}</0>",
  "I understand": "I understand",
  "Privacy Notes": "Privacy Notice",
  "One more thing": "One more thing",
  "Before we begin": "Before we begin",
  "extra-terms-generic": "Attached you will find a file from {{realm}} with important information. <0>Download and read the file</0> to learn more.",
  "extra-terms-kompetens": "Attached you will find information about how you report time after doing a learning. <0>Download and read the file</0> to learn how to.",
  "I have read it!": "I have read it!",
  "Create a profile": "Create a profile",
  "Let's go": "Get started",
  "New Terms of Use & Privacy Notes:": "New Terms of Use & Privacy Notice:",
  "First name": "First name",
  "Last name": "Last name",
  "Something went wrong": "Something went wrong"
}
